import React from 'react';
import { motion } from 'framer-motion';
import { ExclamationTriangleIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

export default function ExpiredLinkMessage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-lg bg-yellow-50 p-4 max-w-4xl mx-auto mt-8"
    >
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">Session link expired or invalid</h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p>
              Please contact our team for a new access code.
            </p>
          </div>
          <div className="mt-4">
            <a
              href="mailto:sales@hupo.co"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
            >
              <EnvelopeIcon className="h-5 w-5 mr-2" />
              Contact Sales Team
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
}